// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"74519eda","345":"10807aa5"}[chunkId] + ".chunk.js";
};